export default function EditPostOfficeModal({
  editingPostOffice, setEditingPostOffice,
  postOfficeSearchName, setPostOfficeSearchName,
  handleSearchPostOffice, handleUpdatePostOffice,
  searchingPostOffice, setError, setSuccess
}) {
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "1rem" }}>
      <div className="card" style={{ maxWidth: "600px", width: "100%" }}>
        <h3 style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: "1rem" }}>
          Edit Post Office - {editingPostOffice.originalName}
        </h3>
        <p style={{ fontSize: "0.875rem", color: "#64748b", marginBottom: "1rem" }}>
          Changes will apply to all routes going to this post office.
        </p>
        <div style={{ background: "#f0f9ff", border: "2px solid #bfdbfe", padding: "1rem", borderRadius: "8px", marginBottom: "1.5rem" }}>
          <label className="form-label" style={{ marginBottom: "0.5rem" }}>🔍 Search Post Office by Name</label>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <input type="text" className="form-input" value={postOfficeSearchName} onChange={(e) => setPostOfficeSearchName(e.target.value)} placeholder="e.g., Topeka Post Office, Harrisonburg Post Office Facility" style={{ flex: 1 }} />
            <button className="btn btn-primary" onClick={handleSearchPostOffice} disabled={searchingPostOffice} style={{ whiteSpace: "nowrap" }}>
              {searchingPostOffice ? "Searching..." : "Find Address"}
            </button>
          </div>
          <p style={{ fontSize: "0.75rem", color: "#64748b", marginTop: "0.5rem" }}>AI will search for the official USPS address for this post office</p>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label className="form-label">Post Office Name</label>
          <input type="text" className="form-input" value={editingPostOffice.newName} onChange={(e) => setEditingPostOffice({ ...editingPostOffice, newName: e.target.value, newAddress: { ...(editingPostOffice.newAddress || {}), name: e.target.value } })} />
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label className="form-label">Street Address</label>
          <input type="text" className="form-input" value={editingPostOffice.newAddress?.address_line1 || ""} onChange={(e) => setEditingPostOffice({ ...editingPostOffice, newAddress: { ...(editingPostOffice.newAddress || {}), address_line1: e.target.value } })} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
          <div>
            <label className="form-label">City</label>
            <input type="text" className="form-input" value={editingPostOffice.newAddress?.city || ""} onChange={(e) => setEditingPostOffice({ ...editingPostOffice, newAddress: { ...(editingPostOffice.newAddress || {}), city: e.target.value } })} />
          </div>
          <div>
            <label className="form-label">State</label>
            <input type="text" className="form-input" value={editingPostOffice.newAddress?.state || ""} onChange={(e) => setEditingPostOffice({ ...editingPostOffice, newAddress: { ...(editingPostOffice.newAddress || {}), state: e.target.value } })} />
          </div>
        </div>
        <div style={{ marginBottom: "1.5rem" }}>
          <label className="form-label">ZIP Code</label>
          <input type="text" className="form-input" value={editingPostOffice.newAddress?.zip || ""} onChange={(e) => setEditingPostOffice({ ...editingPostOffice, newAddress: { ...(editingPostOffice.newAddress || {}), zip: e.target.value } })} />
        </div>
        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "flex-end" }}>
          <button className="btn btn-outline" onClick={() => { setEditingPostOffice(null); setPostOfficeSearchName(""); setError(""); setSuccess(""); }}>Cancel</button>
          <button className="btn btn-primary" onClick={handleUpdatePostOffice}>Update All Routes</button>
        </div>
      </div>
    </div>
  );
}